<script setup>
import { inject, computed } from "vue";
import MIcon from "@/components/m/MIcon.vue";

const props = defineProps({
  title: { type: String, default: "" },
  sub: { type: String, default: "" },
  back: { type: Boolean, default: false },
});
const emit = defineEmits(["back"]);

const ctx = inject("mctx");
const ws = computed(() => ctx.workspace.value);
const isDark = computed(() => ctx.theme.value === "dark");
</script>

<template>
  <div class="btm-header">
    <button
      v-if="back"
      class="btm-iconbtn"
      aria-label="Back"
      @click="emit('back')"
    >
      <MIcon name="chevright" :size="18" style="transform: rotate(180deg)" />
    </button>
    <button
      v-else
      class="btm-wsbtn"
      aria-label="Switch workspace"
      @click="ctx.openWs()"
    >
      <span
        class="btm-ava"
        :style="ws ? { background: ws.color, color: ws.ink } : null"
        >{{ ws ? ws.initial : "?" }}</span
      >
      <span class="btm-wschev"
        ><MIcon name="chevdown" :size="11" :sw="2.4"
      /></span>
    </button>

    <div style="flex: 1; min-width: 0">
      <div class="btm-title" :style="{ fontSize: back ? '20px' : '26px' }">
        {{ title }}
      </div>
      <div v-if="sub" class="btm-sub">{{ sub }}</div>
    </div>

    <button class="btm-iconbtn" aria-label="Toggle theme" @click="ctx.toggle()">
      <MIcon :name="isDark ? 'sun' : 'moon'" :size="18" />
    </button>
  </div>
</template>
